module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    directives: [{
      name: "iscroll",
      rawName: "v-iscroll"
    }],
    staticClass: "office-inner"
  }, [_c('div', {
    staticClass: "warp-pre"
  }, _vm._l((_vm.listArr), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.link(false)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#/index/office-detail"
      }
    }, [_c('div', {
      staticClass: "head-warp",
      class: {
        active: item.swite
      }
    }, [_vm._v("办证室" + _vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "body-warp"
    }, [_c('span', [_vm._v("公证员："), _c('i', [_vm._v(_vm._s(item.peop))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("正在办理：" + _vm._s(item.server))])])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-145c92db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/office-list.vue
// module id = 173
// module chunks = 1